const SiteHostname = 'signalstickermaker.com';
export default {
  SiteHostname
};